import React, { useState } from "react";

export default function InlineCode({ children }) {
  const [copied, setCopied] = useState(false);

  const handleClick = async () => {
    try {
      await navigator.clipboard.writeText(String(children));
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <code
      onClick={handleClick}
      title="Click to copy"
      style={{
        background: "#f3f3f3",
        padding: "2px 6px",
        borderRadius: 6,
        cursor: "pointer",
      }}
    >
      {copied ? "Copied" : children}
    </code>
  );
}
